import Status from "components/base/Status";
import { Fragment } from "react";
import { BsArrowRight } from "react-icons/bs";

export const PROJECT_STATES = [
  "PACKAGING",
  "TRIAL_ORDER",
  "READY_FOR_ORDERS",
  "PUBLIC_RELEASE",
];

const StatusChainView = ({ status }) => {
  if (status === "CANCELED" || status === "ON_HOLD" || status === "ARCHIVED")
    return <Status status={status} />;

  return (
    <div className="flex items-center space-x-2">
      {PROJECT_STATES.map((i, index) => (
        <Fragment key={index}>
          {index === 0 ? null : (
            <BsArrowRight
              className={
                PROJECT_STATES.indexOf(status) >= index ? "" : " opacity-30"
              }
            />
          )}
          <Status status={i} active={PROJECT_STATES.indexOf(status) >= index} />
        </Fragment>
      ))}
    </div>
  );
};

export default StatusChainView;
